import React, { useEffect, useState } from 'react'
import Tab from '../../../../../component/Tabs/Tab';
import ContentBasic from './ContentBasic';

const Personal = ({ employee }) => {

  const [activeTab, setActiveTab] = useState("basic");
  const tabHeader = [
    {
      "key": "basic",
      "label": "Basic Info",
    },
    {
      "key": "family",
      "label": "Family"
    },
    {
      "key": "emergency_contact",
      "label": "Emergency Contact"
    }
  ];

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const TabContent = () => {
    if (activeTab == 'basic') {
      return <ContentBasic employee={employee} />;
    } else if (activeTab == 'family') {
      return <h1>Family</h1>;
    } else if (activeTab == 'emergency_contact') {
      return <h1>Emergency Contact</h1>;
    }
  }

  return (
    <div className='w-full p-5'>
      <div className='flex items-center justify-between'>
        <h1>Personal</h1>
      </div>

      <div className="tabs">
        {tabHeader.map((tab) => (
          <Tab name={tab.key} label={tab.label} activeTab={activeTab} onClick={() => {
            handleTabClick(tab.key)
          }} />
        ))}
      </div>
      <TabContent />
    </div>
  )
}

export default Personal;
